var map = {
	"./animations/ARCity.mp4": 8121,
	"./animations/ARCity.webm": 3909,
	"./animations/DataPioneers.mp4": 787,
	"./animations/DataPioneers.webm": 6908,
	"./animations/DataStream.mp4": 3683,
	"./animations/DataStream.webm": 1036,
	"./animations/DigitalTwin.mp4": 3949,
	"./animations/DigitalTwin.webm": 3680,
	"./animations/NOE-Map.mp4": 781,
	"./animations/NOE-Map.webm": 5222,
	"./animations/Narrativ.mp4": 5761,
	"./animations/Narrativ.webm": 5750,
	"./animations/PublicPrivacy.mp4": 2469,
	"./animations/PublicPrivacy.webm": 6214,
	"./data": 801,
	"./data.json": 801,
	"./de_01.mp3": 1833,
	"./de_02.mp3": 4912,
	"./de_03.mp3": 6701,
	"./de_04.mp3": 7357,
	"./de_05.mp3": 3212,
	"./de_06.mp3": 6451,
	"./de_07.mp3": 190,
	"./de_08.mp3": 6876,
	"./de_09.mp3": 5551,
	"./de_10.mp3": 2133,
	"./de_11.mp3": 7923,
	"./de_12.mp3": 7884,
	"./de_13.mp3": 4423,
	"./de_14.mp3": 9690,
	"./de_15.mp3": 4175,
	"./en_01.mp3": 2034,
	"./en_02.mp3": 7511,
	"./en_03.mp3": 3356,
	"./en_04.mp3": 7242,
	"./en_05.mp3": 9588,
	"./en_06.mp3": 4900,
	"./en_07.mp3": 7792,
	"./en_08.mp3": 5034,
	"./en_09.mp3": 1509,
	"./en_10.mp3": 2159,
	"./en_11.mp3": 8875,
	"./en_12.mp3": 8623,
	"./en_13.mp3": 5448,
	"./en_14.mp3": 7374,
	"./en_15.mp3": 9282,
	"./images/ARCity.png": 6469,
	"./images/DataPioneers.png": 3054,
	"./images/DataStream.png": 6113,
	"./images/DigitalTwin.png": 8122,
	"./images/NOE-Map.png": 1018,
	"./images/Narrativ.png": 4935,
	"./images/PublicPrivacy.png": 5493
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6482;